import { call, put, select, takeLatest } from "redux-saga/effects";
import { REHYDRATE_COMPLETE } from "constants/actionTypes";

import {
  requestLogout,
  appUpdateLogoutRequired,
  setLastKnownVersion,
} from "actions";
import { requiresLogout, getCurrentVersion } from "lib/version";
import toast, { UPDATE_TOAST_MESSAGE_LOGOUT } from "lib/toast";

export function* checkVersion(): Generator {
  const {
    system: { lastKnownVersion },
  } = (yield select()) as State;

  const currentVersion = getCurrentVersion();

  if (requiresLogout(lastKnownVersion, currentVersion)) {
    yield put(requestLogout());
    yield put(appUpdateLogoutRequired());
    yield call([toast, toast.refreshPrompt], UPDATE_TOAST_MESSAGE_LOGOUT);
  }

  if (currentVersion) {
    yield put(setLastKnownVersion(currentVersion));
  }
}

export function* versionSaga(): Generator {
  yield takeLatest(REHYDRATE_COMPLETE, checkVersion);
}

export default versionSaga;
